/**
 * Nom de fichier accepte comme cle Supabase Storage, en restant lisible.
 *
 * Storage refuse les cles non ASCII : les accents sont retires. Les espaces
 * deviennent _, la casse, les tirets et les underscores sont conserves ; tout
 * autre caractere est retire. L'appelant ajoute le prefixe horodate
 * `${Date.now()}_`, qui rend la cle unique (plus d'ecrasement silencieux).
 */
export const safeStorageName = (name) => {
  const clean = String(name || '')
    ?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '')
    ?.replace(/\s+/g, '_')
    ?.replace(/[^A-Za-z0-9._-]/g, '')
    ?.replace(/_+/g, '_')
    ?.replace(/^[._]+/, '');
  return clean || 'document';
};

/** Nom affiche : la cle Storage sans son prefixe horodate. */
export const displayStorageName = (name) => String(name || '')?.replace(/^\d{10,}_/, '');

export default safeStorageName;
